module.exports = __webpack_public_path__ + "static/media/tabla.614a3ead.svg";